export const HANDLE_IS_LOADING = 'controls/HANDLE_IS_LOADING'
export const HANDLE_IS_HISTORY_SIDEBAR_OPEN = 'controls/HANDLE_IS_HISTORY_SIDEBAR_OPEN'
